module.exports = __webpack_public_path__ + "img/blue_175.7def9dc6.png";